import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { VerificationApplication } from "@models";
import { Helper } from "@helpers/functions";
import snsWebSdk from "@sumsub/websdk";
import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { TranslationService } from "@core-services/translation.service";

@Injectable({
	providedIn: "root"
})
export class SumsubService {
	constructor(private apicallService: ApicallService) {}

	async init(token: string, language: string): Promise<void> {
		const lang_iso = TranslationService.getLanguageIsoCode(language);
		let snsWebSdkInstance = snsWebSdk
			.init(token, () => this.getNewAccessToken(language))
			.withConf({
				lang: lang_iso,
				uiConf: {
					customCssStr:
						":root { --black: #000000; --grey: #F5F5F5; --grey-darker: #B2B2B2; --border-color: #DBDBDB;}p { color: var(--black); font-size: 16px; line-height: 24px;}section { margin: 40px auto;}input { color: var(--black); font-weight: 600; outline: none;}section.content { background-color: var(--grey); color: var(--black); padding: 40px 40px 16px; box-shadow: none; border-radius: 6px;}button.submit,button.back { text-transform: capitalize; border-radius: 6px;  height: 48px;  padding: 0 30px; font-size: 16px; background-image: none !important; transform: none !important; box-shadow: none !important; transition: all 0.2s linear;}button.submit { min-width: 132px; background: none; background-color: var(--black);}.round-icon { background-color: var(--black) !important; background-image: none !important;}"
				}
			})
			.withOptions({ addViewportTag: false, adaptIframeHeight: true })
			.onMessage((event) => this.handleMessage(event))
			.build();
		snsWebSdkInstance.launch("#sumsub-websdk-container");
	}

	private getNewAccessToken(language: string): Promise<string> {
		return new Promise((res, rej) => {
			this.apicallService
				.get("verification/sumsub/" + language, new ApicallOption(VerificationApplication))
				.pipe(take(1))
				.subscribe(
					(a: VerificationApplication[]) => {
						res(a[0].getToken());
					},
					(e) => {
						Helper.handleError(e);
						rej();
					}
				);
		});
	}

	private handleMessage(event: string): void {
		if (event === "idCheck.onApplicantSubmitted") {
			const option = new ApicallOption(null, { event: "verification_finished" });
			this.apicallService.post("verification/sumsub/update_status", option).pipe(take(1)).subscribe();
		}
	}
}
